/* eslint-disable @nx/enforce-module-boundaries */
import {
  Card,
  Heading,
  Scrollable,
  Stack,
  VStack,
  Button,
  Container,
  Box,
} from '@mybridge/ui';
import { forwardRef } from 'react';
import { ProfileLayout } from 'v4/snippets/profile/layout';
import { MyNetwork } from 'v4/snippets/profile/network';
import { MyNetworkSecondDegreeListing } from 'v4/snippets/profile/network/my-circle-listing/my-second-degree-listing';
import { MyNetworkMyCircleTabs } from 'v4/snippets/profile/network/my-circle-listing/tabs';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import NetworkPageSidebar from 'v4/components/network/network-sidebar';
import { isMobile } from 'react-device-detect';
import { SiteShortcutLinks } from 'v4/snippets/dashboard/site-shortcut-links';
import { DashboardMyCircle } from 'v4/snippets/dashboard/circle';
import style from '../../../../../components/header/status-dropdown/statusProfile.module.scss';

export const MyNetworkSecondDegree = forwardRef(({ ...props }, ref) => {
  return (
    <AuthenticatedProviders>
      {isMobile ? <Box py={3}>
      <MyNetworkMyCircleTabs active={1} />
                <MyNetworkSecondDegreeListing />
      </Box> : <>
        <Stack
          spacing={4}
          alignItems="flex-start"
          direction={['column', 'row']}
          // p={3}
          minH={['auto', 'auto', '100vh']}
        >

               <Stack
                display={['none', 'none', 'flex']}
                position="sticky"
                top="64px"
                spacing={2}
                // bg="white"
                // boxShadow="2px 0px 6px 0px #00000033"
                minH={isMobile?"90vh":""}
                // borderBottom="1px solid #e0e0e094"
                height={'500px'}
                zIndex="999"
                className={style.leftNetwork}
              >
                <SiteShortcutLinks />

                <Box className={style.hideTitle}>
                  <DashboardMyCircle h="300px" flex="1" />
                </Box>
              </Stack>
         {isMobile?(
          <Scrollable pos="sticky" top="64px" w="300px" maxH="400px">
          <NetworkPageSidebar isActive={'my-circle'} />
        </Scrollable>

         ):(
          <VStack pos="sticky" top="64px" w="300px" maxH="400px">
            <NetworkPageSidebar isActive={'my-circle'} />
          </VStack>
         )} 

          <Stack pos={"relative"} gap={'0px'} pl={{ base: 0, md: 0, lg: '95px' }} w="full" justifyContent="center" mb={5}>
            <Container gap={'0px'} maxW="100%">
              <Box pl={0} p={[0, 1, 1]} pt={[3, 4, 4]} mb={3}>
                <MyNetworkMyCircleTabs active={1} />
                <MyNetworkSecondDegreeListing />
              </Box>
            </Container>
          </Stack>
        </Stack>
      </>}
      
    </AuthenticatedProviders>
  );
});
export default MyNetworkSecondDegree;
